import { DurationValue } from '@travelity/api/services';

export const durationToMinutes = (routeDuration: DurationValue) => {
    if (!routeDuration) return 0;

    const { day = 0, hour = 0, minute = 0 } = routeDuration;
    const minutesFromDay = day * 24 * 60;
    const minutesFromHour = hour * 60;

    return minutesFromDay + minutesFromHour + minute;
};

export const combineArrivalStopDuration = (
    arrivalDuration: DurationValue,
    stopDuration: DurationValue
) => durationToMinutes(arrivalDuration) + durationToMinutes(stopDuration);
